import ReactModal from "react-modal";
import css from "./Modal.module.css";
import { useEffect } from "react";
import clsx from "clsx";

export default function Modal({
  isOpen,
  onClose,
  children,
  allowOverlayClickClose = true,
  shouldCloseOnEsc = true,
  monitoring = false,
}) {
  return (
    <ReactModal
      className={css.modal}
      overlayClassName={clsx(css.overlay, monitoring && css.modalBackdrop)}
      isOpen={isOpen}
      shouldCloseOnEsc={shouldCloseOnEsc}
      shouldCloseOnOverlayClick={allowOverlayClickClose}
      ariaHideApp={false}
      onRequestClose={onClose}
      bodyOpenClassName="modal-open"
      onAfterClose={() => {
        const openedModals = document.querySelectorAll(
          ".ReactModal__Overlay"
        ).length;
        if (openedModals === 0) {
          document.body.classList.remove("modal-open");
        }
      }}
    >
      <>{children}</>
    </ReactModal>
  );
}
